import React from 'react';
import WhatWeDoPage from '../components/WhatWeDoPage';

const ProgramManagement = () => {
  const content = (
    <>
      <h2 id="personal-growth-lab">Blue Point Personal Growth Labs</h2>
      <h3>Care and Wellness Centre for Children and Families</h3>
      <p>
        Blue Point Personal Growth Labs is a network of centres across the state dedicated to
        providing comprehensive psychosocial support for children, young adults, and their families.
        We focus on nurturing emotional well-being, building resilience, strengthening relationships,
        and empowering individuals to move forward with confidence.
      </p>
      <p>
        Our approach is holistic, combining professional guidance, structured programs, and
        compassionate care to support individuals at every stage of their personal growth journey.
      </p>

      <h3>Our Services</h3>
      <ul>
        <li>Counselling and Guidance for children and youth</li>
        <li>Parental Training and Counselling to strengthen family support systems</li>
        <li>Life Skills Education and Personality Development programs</li>
        <li>Academic Support and Guidance for improved learning outcomes</li>
        <li>Self-Confidence and Self-Esteem Building initiatives for children</li>
        <li>Career Guidance and Planning programs</li>
        <li>
          Targeted Interventions for concerns such as anger management, substance use,
          excessive mobile use, depression, anxiety, stress, and trauma
        </li>
        <li>Mentoring and Handholding Support, both short-term and long-term</li>
        <li>Referral Services to Psychiatry and Clinical Psychology professionals</li>
      </ul>

      <h2 id="change-makers">Blue Point Change Makers</h2>
      <h3>Training and Development Program for Young Professionals</h3>
      <p>
        Blue Point Change Makers is a structured training and development initiative designed for
        postgraduates in Social Work, Psychology, Management, and individuals aspiring to build a
        meaningful career in the social sector.
      </p>
      <p>
        This six-month intensive program blends capacity building with real-world field engagement,
        offering participants a unique opportunity to learn, practice, and grow under expert guidance.
        Through a combination of training, supervised practice, mentorship, and hands-on project
        involvement, the program aims to nurture a cadre of competent, socially committed young
        professionals.
      </p>

      <h3>Program Highlights</h3>
      <ul>
        <li>Structured Training Sessions led by experienced professionals</li>
        <li>Field-Based Practical Engagement across diverse community settings</li>
        <li>Mentoring and Supervision by expert faculty</li>
        <li>Reporting and Documentation for professional skill development</li>
        <li>Exposure Visits and Reflective Learning opportunities</li>
        <li>Experience Certificate upon successful completion of the six-month program</li>
        <li>Opportunities to Design and Lead Innovative Projects, even beyond the training period</li>
      </ul>

      <h4>Trainees will gain hands-on experience in:</h4>
      <ul>
        <li>Community Development</li>
        <li>Medical and Psychiatric Social Work</li>
        <li>Family and Child Welfare</li>
        <li>Human Resource Management</li>
      </ul>

      <h2 id="catalysts">Blue Point Catalysts</h2>
      <h3>Human Resources and Organization Development Centre</h3>
      <p>
        The Blue Point works with the Corporates, Governmental and Non-Governmental
        Organisations and Development Programmes to build their Human Resources and catalysing
        the organisation development initiatives. We support institutions and teams by improving
        leadership skills, workplace well-being, and organisational effectiveness through tailor-made
        and high impact capacity building programs.
      </p>
      <p>
        We specialize in enhancing human potential and organizational performance across
        government, corporate, and nonprofit sectors. Our comprehensive services are designed to
        drive personal and organizational growth, foster leadership, and create a culture of excellence.
      </p>
      <p>
        The Blue Point is a leading provider of human resources and organizational development
        solutions. With a focus on people, processes, and performance, we help organizations build
        dynamic work environments that align with their strategic goals.
      </p>
      <p>
        We specialize in transforming workplaces through strategic human resource management and
        organizational development.
      </p>
      <p>
        Our mission is to empower organizations to unlock their full potential by fostering a culture of
        growth, inclusivity, and excellence. Whether you're looking to optimize HR processes, enhance
        employee engagement, or drive organizational change, we are your trusted partner.
      </p>

      <h3>Our Expertise</h3>
      <h4>Personal & Organisational Effectiveness</h4>
      <p>
        Empowering individuals and organizations to achieve their highest potential by optimizing
        performance and efficiency. We work with government agencies, NGOs, and corporate sectors
        to drive impactful change.
      </p>

      <h4>Training Needs Assessment and Module Development</h4>
      <p>
        We identify skill gaps and design customized training modules tailored to your organization's
        specific needs. Our approach ensures measurable outcomes and sustained growth.
      </p>

      <h4>Tailored Solutions for Diverse Sectors</h4>
      <ul>
        <li>Corporate Organizations: Enhance workforce productivity and foster innovation.</li>
        <li>Service Sector Organizations: Improve customer engagement and operational efficiency.</li>
        <li>Non-Governmental Organizations (NGOs): Build capacity and empower teams to create social impact.</li>
      </ul>

      <h4>Strategic Planning, Team Building, and Leadership Development</h4>
      <p>
        Equip your teams with the tools to succeed in a dynamic environment. From crafting strategic
        plans to fostering collaboration and nurturing leadership qualities, we ensure your
        organization is prepared for future challenges.
      </p>

      <h4>Soft Skills Development Programs</h4>
      <p>
        Master essential interpersonal and communication skills that set your organization apart. We
        help develop the confidence and professionalism needed to thrive in today's competitive
        world.
      </p>
    </>
  );

  return (
    <WhatWeDoPage
      title="Programme Management"
      description="Blue Point Personal Growth Labs, Change Makers, and Catalysts"
      content={content}
      image="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600"
    />
  );
};

export default ProgramManagement;
